import ServerSettings from "../../../gd/settings/server-settings/server-settings";

const fieldsConfig = {
    'currentView': {
        type            : 'value',
        defaultValue    : 'list',
    },
}

const debug = false
// const debug = "UserSettingsUsersManagement"

export default class UserSettingsUsersManagement extends ServerSettings {

    public currentView: any

    constructor(config: any) {

        super(config, fieldsConfig);

        // default current view
        this.currentView    = this.initValue('currentView')
    }


    toJson() {
        const result = {};

        this.valueToJson(result, 'currentView')

        debug && console.log(debug, 'toJson', result, this)

        return result;
    }
}
